import { Component, inject } from '@angular/core';
import { CropCodeService } from 'orchestrator';
import { ListService } from '@abp/ng.core';
import {
  CardComponent,
  CardBodyComponent,
  ConfirmationService,
} from '@abp/ng.theme.shared';
import {
  CropCodeCreateDto,
  CropCodeDto,
  CropCodeExcelDownloadDto,
  CropCodeUpdateDto,
} from '../proxy/planning/dtos/crop-code';
import { CROPCODE_CONFIG, CROPCODE_FIELDS } from './crop-code.config';
import { BaseCrudComponent, CrudPage, GenericForm } from '@zendra/shared';

@Component({
  selector: 'app-crop-code',
  imports: [
    CardComponent,
    CardBodyComponent,
    CrudPage,
    GenericForm,
  ],
  providers: [ListService, CropCodeService, ConfirmationService],
  templateUrl: './crop-code.html',
  styleUrl: './crop-code.scss',
})
export class CropCode extends BaseCrudComponent<
  CropCodeDto,
  CropCodeCreateDto,
  CropCodeUpdateDto,
  CropCodeExcelDownloadDto
> {
  service = inject(CropCodeService);
  config = CROPCODE_CONFIG;
  fields = CROPCODE_FIELDS;

  protected prepareUpdateDto(data: any, selected: CropCodeDto): CropCodeUpdateDto {
    return {
      dominantHeight: data.dominantHeight,
      treeCount: data.treeCount,
      averageVolume: data.averageVolume,
      mediumAnnualIncrement: data.mediumAnnualIncrement,
      isOwnPlantation: data.isOwnPlantation,
      geneticMaterialTypeId: data.geneticMaterialTypeId,
      regionId: data.regionId,
      speciesId: data.speciesId,
      concurrencyStamp: selected.concurrencyStamp,
    };
  }

  protected getEntityName(): string {
    return 'CropCode';
  }
}
